import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button, Form, Card } from "react-bootstrap";
import Layout from "../../layout/Layout";
import Switch from "react-switch";
import { toast } from "react-toastify";
import { API } from "../../App";
import Cookies from "js-cookie";

const DashboradWidgetsAdd = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [LoadData, setLoadData] = useState([]);
  const [validate, setValidate] = useState(false);
  const [cat, setCategory] = useState([]);
  const [themes, setThemes] = useState([]);
  const [variants, setVariants] = useState([]);

  const addVariant = () => {
    setVariants([
      ...variants,
      {
        widget_type: "",
        preview_image: null,
        widget_image: null,
        clock_image: null,
        quote: "",
        text_color: "",
        font_name: "",
        alignment: "",
        sort_order: "",
        status: true,
      },
    ]);
  };
  const removeVariant = (i) => {
    const d = [...variants];
    d.splice(i, 1);
    setVariants(d);
  };
  const variantChange = (e, i, isFile) => {
    const d = [...variants];
    d[i][e.target.name] = isFile ? e.target.files[0] : e.target.value;
    setVariants(d);
  };
  const [loading, Setloading] = useState(false);
  const [status, setstatus] = useState(true);
  const [is_premium, setis_premium] = useState(true);

  const [user, setuser] = useState({
    rank: "",
    category_id: "",
    dashboard_theme_id: "",
    widget_name: "",
    alignment: "",
    quote: "",
  });

  const handdelsubmission = async () => {
    // Widgets (design) — validate only Required=Yes fields
    if (user.rank === "" || !user.rank) {
      setValidate(true);
    } else if (!user.dashboard_theme_id) {
      setValidate(true);
    } else if (!user.widget_name) {
      setValidate(true);
    } else if (user.category_id === "" || !user.category_id) {
      setValidate(true);
    } else if (variants.length < 1) {
      setValidate(true);
      toast.error("At least one Widget Size (variant) is required", {
        position: "bottom-right",
        autoClose: 2000,
      });
    } else {
      const formdata = new FormData();
      formdata.append("rank", user.rank);
      formdata.append("category_id", user.category_id);
      formdata.append("dashboard_theme_id", user.dashboard_theme_id);
      formdata.append("widget_name", user.widget_name);
      formdata.append("status", status);
      formdata.append("is_premium", is_premium);
      // validate required (Yes) fields for each widget size variant
      for (const v of variants) {
        if (!v.preview_image || !v.widget_image) {
          setValidate(true);
          Setloading(false);
          toast.error(
            "Please fill all required Widget Size fields (Preview Image, Widget Image)",
            { position: "bottom-right", autoClose: 2000 },
          );
          return;
        }
      }

      const token = Cookies.get("jwt");
      const res = await API.post("/dashboardWidgets", formdata, {
        headers: { authorization: `Bearer ${token}` },
      });
      if (res.data.status === true) {
        const newWidgetId = res.data.data?._id;
        // create each size variant against the new widget
        let variantError = null;
        for (const v of variants) {
          const vfd = new FormData();
          vfd.append("widget_id", newWidgetId);
          vfd.append("widget_type", v.widget_type);
          vfd.append("preview_image", v.preview_image);
          vfd.append("widget_image", v.widget_image);
          if (v.clock_image) vfd.append("clock_image", v.clock_image);
          vfd.append("quote", v.quote);
          vfd.append("text_color", v.text_color);
          vfd.append("font_name", v.font_name);
          vfd.append("alignment", v.alignment);
          vfd.append("sort_order", v.sort_order || "");
          vfd.append("status", v.status);
          const vres = await API.post("/widgetVariants", vfd, {
            headers: { authorization: `Bearer ${token}` },
          });
          if (vres.data.status !== true && vres.data.response_code !== 1) {
            variantError = vres.data.response_message || "Variant save failed";
            break;
          }
        }
        Setloading(false);
        if (variantError) {
          toast.error("Widget saved but a size failed: " + variantError, {
            position: "bottom-right",
            autoClose: 3000,
          });
        } else {
          toast.success("Data Save Sucessfully", {
            position: "bottom-right",
            autoClose: 500,
          });
        }
        // navigate("/dashbordwidgets")
      } else {
        Setloading(false);
        toast.error(res.data.response_message || "Something went wrong!");
      }
    }
  };

  const lodadata = async () => {
    const catRes = await API.post("/widget_category");
    setCategory(catRes.data.data[0].get_SubCategory);

    const token = Cookies.get("jwt");
    const themeRes = await API.post(
      "/dashboardThemesData",
      {},
      { headers: { authorization: `Bearer ${token}` } },
    );
    setThemes(themeRes.data.data || []);
  };

  const onInputchange = (e) => {
    setuser({ ...user, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    lodadata();
  }, []);

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3 className="my-1">Add Dashboard Widgets</h3>
      </div>
      <div className="page-content">
        <Form noValidate validated={validate}>
          <Row>
            <Col xs={12}>
              <Card className="mb-4">
                <Card.Body>
                  <Row>
                    <Col lg={3} sm={12}>
                      <Form.Group>
                        <Form.Label htmlFor="m_cate">New Index</Form.Label>
                        <Form.Control
                          type="number"
                          id="cate-img"
                          className="my-2"
                          name="rank"
                          placeholder="Enter Index"
                          onChange={onInputchange}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Enter Index
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={3} xs={12}>
                      <Form.Label htmlFor="m_cate">Category Id</Form.Label>
                      <Form.Select
                        className="my-2"
                        name="category_id"
                        onChange={onInputchange}
                        required
                      >
                        <option value="">Select Category Id</option>
                        {cat.map((val, id) => {
                          return (
                            <option key={id} value={val._id}>
                              {val.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Select Category
                      </Form.Control.Feedback>
                    </Col>
                    <Col lg={3} xs={12}>
                      <Form.Label htmlFor="dashboard_theme_id">
                        Theme
                      </Form.Label>
                      <Form.Select
                        className="my-2"
                        name="dashboard_theme_id"
                        onChange={onInputchange}
                      >
                        <option value="">Select Theme</option>
                        {themes.map((val, id) => {
                          return (
                            <option key={id} value={val._id}>
                              {val.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Col>
                    <Col lg={3} sm={12}>
                      <Form.Group>
                        <Form.Label htmlFor="widget_name">
                          Widget Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="widget_name"
                          name="widget_name"
                          className="my-2"
                          placeholder="e.g. Minimal Clock"
                          onChange={onInputchange}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={3} sm="12">
                      <Form.Label htmlFor="media_type" className="d-block mb-2">
                        Is Premium
                      </Form.Label>
                      <Switch
                        onChange={(checked) => {
                          if (checked === true) {
                            setis_premium(true);
                            console.log(checked, "s-on");
                          } else {
                            setis_premium(false);
                            console.log(checked, "s-off");
                          }
                        }}
                        checked={is_premium === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className="react-switch-off">NO</div>
                        }
                        checkedIcon={<div className="react-switch-on">YES</div>}
                      />
                    </Col>
                    <Col lg={3} sm="12">
                      <Form.Label htmlFor="media_type" className="d-block mb-2">
                        Status
                      </Form.Label>
                      <Switch
                        onChange={(checked) => {
                          if (checked === true) {
                            setstatus(true);
                            console.log(checked, "s-on");
                          } else {
                            setstatus(false);
                            console.log(checked, "s-off");
                          }
                        }}
                        checked={status === true ? true : false}
                        offColor="#C8C8C8"
                        onColor="#0093ed"
                        height={30}
                        width={70}
                        className="react-switch"
                        uncheckedIcon={
                          <div className="react-switch-off">OFF</div>
                        }
                        checkedIcon={<div className="react-switch-on">ON</div>}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-4">
                    <Col
                      xs={12}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <h5 className="mb-0">Widget Sizes (Variants)</h5>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={addVariant}
                        disabled={variants.length >= 3}
                      >
                        Add Size
                      </Button>
                    </Col>
                  </Row>
                  {variants.map((v, ind) => (
                    <div key={ind} className="border rounded-3 my-2 p-3">
                      <Row>
                        <Col lg={3} sm={12}>
                          <Form.Label>Size Type</Form.Label>
                          <Form.Select
                            className="my-2"
                            name="widget_type"
                            value={v.widget_type}
                            onChange={(e) => variantChange(e, ind, false)}
                          >
                            <option value="">Select Size</option>
                            <option value="small">Small</option>
                            <option value="medium">Medium</option>
                            <option value="large">Large</option>
                          </Form.Select>
                        </Col>
                        <Col lg={3} sm={12}>
                          <Form.Label>Preview Image</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="my-2"
                            name="preview_image"
                            onChange={(e) => variantChange(e, ind, true)}
                          />
                        </Col>
                        <Col lg={3} sm={12}>
                          <Form.Label>Widget Image</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="my-2"
                            name="widget_image"
                            onChange={(e) => variantChange(e, ind, true)}
                          />
                        </Col>
                        <Col lg={3} sm={12}>
                          <Form.Label>Clock Image</Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="my-2"
                            name="clock_image"
                            onChange={(e) => variantChange(e, ind, true)}
                          />
                        </Col>
                        <Col lg={3} sm={12}>
                          <Form.Label>Text Color</Form.Label>
                          <Form.Control
                            type="text"
                            className="my-2"
                            name="text_color"
                            value={v.text_color}
                            placeholder="#FFFFFF"
                            onChange={(e) => variantChange(e, ind, false)}
                          />
                        </Col>
                        <Col lg={3} sm={12}>
                          <Form.Label>Font Name</Form.Label>
                          <Form.Control
                            type="text"
                            className="my-2"
                            name="font_name"
                            value={v.font_name}
                            placeholder="e.g. BLOODY"
                            onChange={(e) => variantChange(e, ind, false)}
                          />
                        </Col>
                        <Col lg={2} sm={12}>
                          <Form.Label>Alignment</Form.Label>
                          <Form.Select
                            className="my-2"
                            name="alignment"
                            value={v.alignment}
                            onChange={(e) => variantChange(e, ind, false)}
                          >
                            <option value="">Select</option>
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                          </Form.Select>
                        </Col>
                        <Col lg={2} sm={12}>
                          <Form.Label>Quote</Form.Label>
                          <Form.Control
                            type="text"
                            className="my-2"
                            name="quote"
                            value={v.quote}
                            onChange={(e) => variantChange(e, ind, false)}
                          />
                        </Col>
                        <Col lg={1} sm={12}>
                          <Form.Label className="d-block mb-2">
                            Status
                          </Form.Label>
                          <Switch
                            onChange={(checked) =>
                              variantChange(
                                { target: { name: "status", value: checked } },
                                ind,
                                false,
                              )
                            }
                            checked={v.status === true}
                            offColor="#C8C8C8"
                            onColor="#0093ed"
                            height={30}
                            width={70}
                            className="react-switch"
                            uncheckedIcon={
                              <div className="react-switch-off">OFF</div>
                            }
                            checkedIcon={
                              <div className="react-switch-on">ON</div>
                            }
                          />
                        </Col>
                        <Col lg={1} sm={12} className="align-self-end my-3">
                          <Button
                            variant="danger"
                            size="sm"
                            className="btn-icon"
                            onClick={() => removeVariant(ind)}
                          >
                            <i class="bx bx-x"></i>
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Card.Body>
                <Card.Footer className="text-end">
                  <Button
                    variant="primary"
                    className="me-3"
                    onClick={handdelsubmission}
                  >
                    Save
                  </Button>
                  <Link to="/dashbordwidgets">
                    <Button variant="secondary">Cancle</Button>
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    </Layout>
  );
};

export default DashboradWidgetsAdd;
